import { render, staticRenderFns } from "./addTemplateDialog.vue?vue&type=template&id=04384085&scoped=true"
import script from "./addTemplateDialog.vue?vue&type=script&lang=js"
export * from "./addTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./addTemplateDialog.less?vue&type=style&index=0&id=04384085&prod&lang=less&scoped=true&external"
import style1 from "./addTemplateDialog.vue?vue&type=style&index=1&id=04384085&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04384085",
  null
  
)

export default component.exports